import React from "react";
import { Mui } from "@osu/react-ui";
import useStyles from "../styles";
import { inputMappings as mappings } from "../steps";
import { shouldUseAn } from "../../util/functions";

const MAX_LENGTH_EMAIL = 80;
const REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validateEmail = (email) => {
    return (String(email).toLowerCase().match(REGEX_EMAIL) !== null && email.length <= MAX_LENGTH_EMAIL);
};  

const TextFieldGroup = ({ fieldKey, readOnly, value, error, setValidation, updateState, elevation, ...rest }) => {
  const classes = useStyles({ elevation, readOnly });
  const currentTextField = React.useRef();
  const { labels, autoComplete } = mappings
  if (!fieldKey) {
    return false;
  }
  const labelForField = labels[fieldKey];
  if (!labelForField) {
    return false;
  }

  const id = rest?.id || `${fieldKey}-text-field`;
  const labelId = rest?.labelId || (id + "-label");
  let textFieldProps = {}
  let inputProps = {
    "autoComplete": autoComplete[fieldKey],
  }
  const required = !readOnly
  inputProps["aria-invalid"] = Boolean(error)
  if (!readOnly) {
    inputProps.autoComplete = autoComplete[fieldKey]
    let helperText
    if(error) { 
      textFieldProps.error = error
      helperText = `Please enter `
      if(!value) {
        helperText += shouldUseAn(labelForField) ? "an" : "a"
      } else {
        helperText += "a valid"
      }
      helperText += ` ${labelForField.toLowerCase()}.`
      textFieldProps.helperText = helperText
    }
    textFieldProps.onFocus= (e) => { 
      validateAndSetValidation(e)
    }
    const validateAndSetValidation = (e) => {
      const nextValue = e?.target?.value
      let isNextValueValid = false
      if(fieldKey === mappings.keys.email) {
        if(!nextValue) {
          isNextValueValid = !required
        } else {
          isNextValueValid = validateEmail(nextValue)
          if(!isNextValueValid) {
            e.target.setCustomValidity(helperText || "Please enter a valid email address.");
          }
        }
      } else {
        isNextValueValid = required ? Boolean(nextValue) : true
      }
      if(!isNextValueValid) { 
        inputProps["aria-invalid"] = true
      }
       setValidation(existingValidation => {
        const newValidation = {...existingValidation}
        const wasPreviouslyInValid = existingValidation[fieldKey] === false
        newValidation[fieldKey] = isNextValueValid
        if(wasPreviouslyInValid && isNextValueValid) {
          e.target.setCustomValidity("");
        }
        return newValidation
       });
    }
    textFieldProps.onBlur= (e) => {
      validateAndSetValidation(e)
    }
    textFieldProps.onChange= (e) => {
      updateState(fieldKey, e.target.value)
      validateAndSetValidation(e)
    }
    inputProps.required = required
    if(fieldKey === mappings.keys.email) {
      inputProps["aria-required"] = true
      inputProps.maxLength = MAX_LENGTH_EMAIL
    }

  }
  inputProps.ref = currentTextField

  return (
    <Mui.FormControl variant="outlined" className={classes.formControl}>
      <Mui.FormLabel required={required} id={labelId} htmlFor={id}>
        {labelForField}
      </Mui.FormLabel>
      <Mui.TextField
        {...textFieldProps}
        label=""
        id={id}
        className={classes.textField} 
        variant="outlined" 
        value={value}
        readOnly={readOnly}
        inputProps={inputProps}
      />
    </Mui.FormControl>
  );
};


export default TextFieldGroup